var map = {
	"app/admin/register/register.module": [
		"./src/app/admin/register/register.module.ts",
		"app-admin-register-register-module"
	],
	"app/api-access/api-access.module": [
		"./src/app/api-access/api-access.module.ts",
		"app-api-access-api-access-module~app-system-dashboard-system-dashboard-module",
		"app-api-access-api-access-module"
	],
	"app/associate/associate.module": [
		"./src/app/associate/associate.module.ts"
	],
	"app/exporting-hub/exporting-hub.module": [
		"./src/app/exporting-hub/exporting-hub.module.ts",
		"app-exporting-hub-exporting-hub-module"
	],
	"app/gtin/gtin.module": [
		"./src/app/gtin/gtin.module.ts",
		"app-gtin-gtin-module~app-products-products-module",
		"app-gtin-gtin-module"
	],
	"app/legal-entity/legal-entity.module": [
		"./src/app/legal-entity/legal-entity.module.ts",
		"app-legal-entity-legal-entity-module"
	],
	"app/list/list.module": [
		"./src/app/list/list.module.ts",
		"app-list-list-module"
	],
	"app/organization/organization.module": [
		"./src/app/organization/organization.module.ts"
	],
	"app/products/products.module": [
		"./src/app/products/products.module.ts",
		"app-gtin-gtin-module~app-products-products-module",
		"app-products-products-module"
	],
	"app/publishing/publishing.module": [
		"./src/app/publishing/publishing.module.ts",
		"app-publishing-publishing-module"
	],
	"app/system-dashboard/system-dashboard.module": [
		"./src/app/system-dashboard/system-dashboard.module.ts",
		"app-api-access-api-access-module~app-system-dashboard-system-dashboard-module",
		"app-system-dashboard-system-dashboard-module"
	],
	"app/talent-management/talent-management.module": [
		"./src/app/talent-management/talent-management.module.ts",
		"app-talent-management-talent-management-module"
	],
	"app/training/training.module": [
		"./src/app/training/training.module.ts"
	],
	"app/vendors/vendors.module": [
		"./src/app/vendors/vendors.module.ts",
		"app-vendors-vendors-module"
	],
	"app/work-groups/work-groups.module": [
		"./src/app/work-groups/work-groups.module.ts"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;